import { put, takeLatest, call, all } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  addDepartmentDetailsFailure,
  addDepartmentDetailsResponseChanged,
  addDepartmentDetailsSuccess,
  deleteDepartmentDetailsFailure,
  deleteDepartmentDetailsResponseChanged,
  deleteDepartmentDetailsSuccess,
  fetchDepartmentDetailsFailure,
  fetchDepartmentDetailsResponseChanged,
  fetchDepartmentDetailsSuccess,
  getDepartmentListFailure,
  getDepartmentListResponseChanged,
  getDepartmentListSuccess,
  updateDepartmentDetailsFailure,
  updateDepartmentDetailsResponseChanged,
  updateDepartmentDetailsSuccess,
} from "./department.action";
import DepartmentActionTypes from "./department.types";
import {
  departmentDetailsAdd,
  departmentDetailsDelete,
  departmentDetailsUpdate,
  departmentListForAll,
  departmentListGet,
} from "./department.service";
/** ***************** ADD DEPARTMENT DETAILS START *********************** */
export function* addDepartmentDetails({ payload }: any) {
  const {
    departmentName,
    deptDescription,
    UserID,
    CompanyID,
    UserName,
    InstanceName,
  } = payload;
  try {
    const key = "DepartmentCreateKey";
    const jsonData = {
      DepartmentName: departmentName,
      DepartmentDescription: deptDescription,
      DepartmentHeadID: UserID,
      CompanyID: CompanyID,
      UserName: UserName,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(departmentDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addDepartmentDetailsFailure(responseData.data));
    } else {
      yield put(addDepartmentDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addDepartmentDetailsFailure(error));
  }
}

export function* resetAddDepartmentResponse() {
  yield put(addDepartmentDetailsResponseChanged());
}

export function* onAddDepartmentDetails() {
  yield takeLatest(
    DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_START,
    addDepartmentDetails,
  );
}

export function* onAddDepartmentDetailsResponseReset() {
  yield takeLatest(
    DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_RESPONSE_RESET,
    resetAddDepartmentResponse,
  );
}
/** ***************** ADD DEPARTMENT DETAILS END *********************** */

/** *********************  START UPDATE DEPARTMENT DETAILS  ******************** */
export function* updateDepartmentDetails({ payload }: any) {
  const {
    departmentName,
    deptDescription,
    UserID,
    CompanyID,
    departmentID,
    UserName,
    oldDepartment,
    InstanceName,
  } = payload;
  try {
    const key = "DepartmentUpdateKey";
    const jsonData = {
      DepartmentName: departmentName,
      DepartmentDescription: deptDescription,
      DepartmentHeadID: UserID,
      CompanyID: CompanyID,
      DepartmentID: departmentID,
      UserName: UserName,
      OldDepartmentName: oldDepartment,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(departmentDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateDepartmentDetailsFailure(responseData.data));
    } else {
      yield put(updateDepartmentDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateDepartmentDetailsFailure(error));
  }
}

export function* resetUpdateDepartmentDetailsResponse() {
  yield put(updateDepartmentDetailsResponseChanged());
}

export function* onUpdateDepartmentDetails() {
  yield takeLatest(
    DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_START,
    updateDepartmentDetails,
  );
}

export function* onUpdateDepartmentResponseReset() {
  yield takeLatest(
    DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_RESPONSE_RESET,
    resetUpdateDepartmentDetailsResponse,
  );
}
/** *********************  END UPDATE DEPARTMENT DETAILS ******************** */

/** *********************  START GET DEPARTMENT LIST  ******************** */
export function* listAllDepartmentData({ payload }: any) {
  try {
    const key = "GetAllDepartmentPaginationKey";
    const { CompanyID, Limit, searchValueSet } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      Limit: Limit,
      InputSearch: searchValueSet,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(departmentListForAll, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getDepartmentListFailure(responseData.data));
    } else {
      yield put(getDepartmentListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getDepartmentListFailure(error));
  }
}

export function* resetGetDepartmentListResponse() {
  yield put(getDepartmentListResponseChanged());
}

export function* onGetDepartmentListDetails() {
  yield takeLatest(
    DepartmentActionTypes.GET_DEPARTMENT_LIST_START,
    listAllDepartmentData,
  );
}

export function* onGetDepartmentListResponseReset() {
  yield takeLatest(
    DepartmentActionTypes.GET_DEPARTMENT_LIST_RESPONSE_RESET,
    resetGetDepartmentListResponse,
  );
}
/** *********************  END GET DEPARTMENT LIST ******************** */

/** *********************  START FETCH DEPARTMENT DETAILS  ******************** */
export function* fetchDepartmentDetails({ payload }: any) {
  const { CompanyID, DepartmentID, InstanceName } = payload;
  try {
    const key = "GetDepartmentKey";
    const jsonData = {
      CompanyID: CompanyID,
      DepartmentID: DepartmentID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(departmentListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchDepartmentDetailsFailure(responseData.data));
    } else {
      yield put(fetchDepartmentDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchDepartmentDetailsFailure(error));
  }
}

export function* resetFetchDepartmentDetailsResponse() {
  yield put(fetchDepartmentDetailsResponseChanged());
}

export function* onFetchDepartmentDetails() {
  yield takeLatest(
    DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_START,
    fetchDepartmentDetails,
  );
}

export function* onFetchDepartmentDetailsResponseReset() {
  yield takeLatest(
    DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_RESPONSE_RESET,
    resetFetchDepartmentDetailsResponse,
  );
}
/** *********************  END FETCH DEPARTMENT DETAILS ******************** */

/** *********************  START DELETE DEPARTMENT DETAILS  ******************** */
export function* deleteDepartment({ payload }: any) {
  const { departmentID, DepartmentName, UserName, CompanyID, InstanceName } =
    payload;
  try {
    const key = "DeleteDepartmentKey";
    const jsonData = {
      DepartmentID: departmentID,
      DepartmentName: DepartmentName,
      UserName: UserName,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(departmentDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteDepartmentDetailsFailure(responseData.data));
    } else {
      yield put(deleteDepartmentDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteDepartmentDetailsFailure(error));
  }
}

export function* resetDeleteDepartmentDetailsResponse() {
  yield put(deleteDepartmentDetailsResponseChanged());
}

export function* onDeleteDepartmentDetails() {
  yield takeLatest(
    DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_START,
    deleteDepartment,
  );
}

export function* onDeleteDepartmentDetailsResponseReset() {
  yield takeLatest(
    DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_RESPONSE_RESET,
    resetDeleteDepartmentDetailsResponse,
  );
}
/** *********************  END DELETE DEPARTMENT DETAILS ******************** */

export function* departmentMasterSaga() {
  yield all([
    call(onAddDepartmentDetails),
    call(onAddDepartmentDetailsResponseReset),
    call(onUpdateDepartmentDetails),
    call(onUpdateDepartmentResponseReset),
    call(onGetDepartmentListDetails),
    call(onGetDepartmentListResponseReset),
    call(onFetchDepartmentDetails),
    call(onFetchDepartmentDetailsResponseReset),
    call(onDeleteDepartmentDetails),
    call(onDeleteDepartmentDetailsResponseReset),
  ]);
}
